import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';



  export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const idToken = localStorage.getItem('token')!;
 
  if (!idToken) return next(req);
   
  const cloned = req.clone({
    headers: req.headers.set('Authorization', 'Bearer ' + idToken),
  });
 
  return next(cloned);
    
};
  
  

